const UNKNOWN_WORD_TYPE = {
  UNKNOWN: { value: 'UNKNOWN', label: 'Unknown' },
  PREPARATION_METHOD: {
    value: 'PREPARATION_METHOD',
    label: 'Preparation Method',
  },
  COMMON_ENGLISH_WORD: {
    value: 'COMMON_ENGLISH_WORD',
    label: 'Common English Word',
  },
  COMMON_FOREIGN_WORD: {
    value: 'COMMON_FOREIGN_WORD',
    label: 'Common Foreign Word',
  },
  WHOLE_DISH_NAME: { value: 'WHOLE_DISH_NAME', label: 'Whole Dish Name' },
  NAME: { value: 'NAME', label: 'Name' },
  NOT_RELEVANT: { value: 'NOT_RELEVANT', label: 'Not Relevant' },
  NEW_INGREDIENT: { value: 'NEW_INGREDIENT', label: 'New Ingredient' },
  EXISTING_INGREDIENT: {
    value: 'EXISTING_INGREDIENT',
    label: 'Existing Ingredient',
  },
  DIET_LABEL: { value: 'DIET_LABEL', label: 'Diet Label Legend' },
  ALLERGEN_LABEL: { value: 'ALLERGEN_LABEL', label: 'Allergen Label Legend' },
}

module.exports = UNKNOWN_WORD_TYPE
